"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAME = exports.IS_DEFAULT = exports.COMPANY_ZIP = exports.COMPANY_STREET_ADDRESS_2 = exports.COMPANY_STREET_ADDRESS_1 = exports.COMPANY_STATE = exports.COMPANY_PHONE = exports.COMPANY_NAME = exports.COMPANY_COUNTRY = exports.COMPANY_CITY = exports.CAN_SPAM_SETTING = void 0;
var CAN_SPAM_SETTING = 'CanSpamSetting';
exports.CAN_SPAM_SETTING = CAN_SPAM_SETTING;
var COMPANY_CITY = 'company_city';
exports.COMPANY_CITY = COMPANY_CITY;
var COMPANY_COUNTRY = 'company_country';
exports.COMPANY_COUNTRY = COMPANY_COUNTRY;
var COMPANY_NAME = 'company_name';
exports.COMPANY_NAME = COMPANY_NAME;
var COMPANY_PHONE = 'company_phone';
exports.COMPANY_PHONE = COMPANY_PHONE;
var COMPANY_STATE = 'company_state';
exports.COMPANY_STATE = COMPANY_STATE;
var COMPANY_STREET_ADDRESS_1 = 'company_street_address_1';
exports.COMPANY_STREET_ADDRESS_1 = COMPANY_STREET_ADDRESS_1;
var COMPANY_STREET_ADDRESS_2 = 'company_street_address_2';
exports.COMPANY_STREET_ADDRESS_2 = COMPANY_STREET_ADDRESS_2;
var COMPANY_ZIP = 'company_zip';
exports.COMPANY_ZIP = COMPANY_ZIP;
var IS_DEFAULT = 'is_default';
exports.IS_DEFAULT = IS_DEFAULT;
var NAME = 'name';
exports.NAME = NAME;